import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
    PAGE_VIDEO: '[data-fragment="SignLanguageVideos.pageVideo"]',
    CONTENT_VIDEOS: '[data-fragment="SignLanguageVideos.contentVideos"]',
    TRIGGER_MENU: '[data-fragment="SignLanguageVideos.trigger.menu"]',
    TRIGGER_CONTENT: '[data-fragment="SignLanguageVideos.trigger.content"]',
    TRIGGER_BLOCK: '[data-fragment="SignLanguageVideos.trigger.block"]',
    TRIGGER: '[data-fragment*="SignLanguageVideos.trigger."]',
    VIDEO_POPUP: '[data-fragment="SignLanguageVideos.popup"]',
    VIDEO_POPUP_CONTENT: '[data-fragment="SignLanguageVideos.popup.content"]',
    VIDEO_POPUP_CLOSE: '[data-fragment="SignLanguageVideos.popup.close"]',
};

export default class SignLanguageVideos extends WebComponent {
    constructor(props) {
        super(props);
        this.state = {
            overallEnabled: false,
            popupVisible: false,
        };
        this.overallSwitch = this.overallSwitch.bind(this);
        this.handleTrigger = this.handleTrigger.bind(this);
        this.openVideoPopup = this.openVideoPopup.bind(this);
        this.closeVideoPopup = this.closeVideoPopup.bind(this);
    }
    didMount() {
        const self = this;
        this.pageVideo = document.querySelector(fragments.PAGE_VIDEO);
        this.sectionHeader = document.querySelector('.opening-visual__title');
        this.contentVideos = document.querySelectorAll(fragments.CONTENT_VIDEOS);
        this.menuTriggers = document.querySelectorAll(fragments.TRIGGER_MENU);
        this.contentTriggers = document.querySelectorAll(fragments.TRIGGER_CONTENT);
        this.blockTriggers = document.querySelectorAll(fragments.TRIGGER_BLOCK);
        this.triggers = document.querySelectorAll(fragments.TRIGGER);
        this.videoPopup = document.querySelector(fragments.VIDEO_POPUP);
        this.videoPopupContent = document.querySelector(fragments.VIDEO_POPUP_CONTENT);
        this.videoPopupClose = document.querySelector(fragments.VIDEO_POPUP_CLOSE);

        // anonymous functions
        this._closeVideoOnEscape = function(e) {
            if (self.state.popupVisible && e.key === "Escape") self.closeVideoPopup();
        }

        if (localStorage.getItem('signLanguageVideosOverallEnabled') && localStorage.getItem('signLanguageVideosOverallEnabled') === 'enabled') {
            this.setState({
                overallEnabled: true,
            });
        } else {
            localStorage.setItem('signLanguageVideosOverallEnabled', 'disabled');
        }

        this.element.addEventListener('click', this.overallSwitch);
        this.element.addEventListener('keypress', this.overallSwitch);

        this.menuTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', self.handleTrigger);
            trigger.addEventListener('keypress', self.handleTrigger);
        });

        this.blockTriggers.forEach(function(trigger) {
          trigger.addEventListener('click', self.handleTrigger);
          trigger.addEventListener('keypress', self.handleTrigger);
        });

        if (this.contentVideos.length) {
            let contentVideosCodes = [];
            this.contentVideos.forEach(function(content) {
              const currentContentVideosCodes = content.dataset.videos.split(',');
              currentContentVideosCodes.forEach(function(currentContentVideoCodes) {
                contentVideosCodes.push(currentContentVideoCodes);
              });
            });
            this.contentTriggers.forEach(function(trigger, index) {
                trigger.dataset.videoCode = contentVideosCodes[index];
                trigger.setAttribute('alt', self.element.dataset.localeSignLanguageVideoTrigger);
                trigger.addEventListener('click', self.handleTrigger);
                trigger.addEventListener('keypress', self.handleTrigger);
            });
        }

        this.videoPopupClose.addEventListener('click', this.closeVideoPopup);
    }

    overallSwitch(e) {
        if (e.type === 'click' || (e.type === 'keypress' && (e.keyCode === 13 || e.keyCode === 32))) {
            e.preventDefault();
            if (this.state.overallEnabled) {
                localStorage.setItem('signLanguageVideosOverallEnabled', 'disabled');
                this.setState({
                    overallEnabled: false,
                });
            } else {
                localStorage.setItem('signLanguageVideosOverallEnabled', 'enabled');
                this.setState({
                    overallEnabled: true,
                });
            }
        }
    }

    handleTrigger(e) {
        if (e.type === 'click' || (e.type === 'keypress' && (e.keyCode === 13 || e.keyCode === 32))) {
            e.preventDefault();
            this.openVideoPopup(e.target.dataset.videoCode);
        }
    }

    openVideoPopup(code) {
        this.videoPopupContent.innerHTML = '<iframe width="786" height="442" src="https://www.youtube.com/embed/'+code+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        this.setState({
            popupVisible: true,
        });
        document.addEventListener('keyup', this._closeVideoOnEscape);
    }

    closeVideoPopup() {
        this.videoPopupContent.innerHTML = '';
        this.setState({
            popupVisible: false,
        });
        document.removeEventListener('keyup', this._closeVideoOnEscape);
    }

    update() {
        const {
            overallEnabled,
            popupVisible,
        } = this.state;
        classNames(this.element, { active: overallEnabled });
        classNames(this.videoPopup, { active: popupVisible });
        this.triggers.forEach(function(trigger) {
            classNames(trigger, { active: overallEnabled });
        });
    }
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/SignLanguageVideos.js